export const questionTypes = [
  'text',
  'radio',
  'dropdown',
  'textarea',
  'number',
  'file',
  'checkbox',
] as const

type QuestionType = typeof questionTypes[number]
export default QuestionType
